import { URLS } from '@/configs/urls'
import { USER_ROLE_CLUB } from '@/features/tasks/fanTasksAccess'

export function resolveForClubsFanRedirect(
  pathname: string,
  roles: string[] | undefined
): string | null {
  if (!pathname.startsWith(URLS.FOR_CLUBS)) {
    return null
  }

  if (!roles?.length || roles.includes(USER_ROLE_CLUB)) {
    return null
  }

  return URLS.FANS
}
